<template>
  <v-container
    ref="container"
    fluid
    :class="[
    'index-page-alignment',
    (platform == 'Marketing') ? 'marketing-order-detail' : 'service-order-detail'
    ]"
  >
    <v-row>
      <v-col class="index-breadcrumb-alignment">
        <v-breadcrumbs
          class="pa-0"
          :items="breadcrumbs"
          divider=">"
        />
      </v-col>
    </v-row>
    <header>
      <v-row class="index-header-alignment d-flex">
        <v-col
          cols="10"
          class="pa-0"
        >
          <h2 class="font-weight-medium-custom mb-0 text-capitalize">Order Details</h2>
        </v-col>
        <v-col
          cols="2"
          class="pa-0 mt-n1"
        >
          <v-select
            v-model="source"
            v-track="'filter-order-by-source'"
            class="filter-order-by-source"
            :items="sources"
            required
            attach
            item-value="id"
            :item-text="item => item.name"
            item-color="rgba(0,0,0,0.87)"
            :menu-props="{ offsetY: true }"
            dense
            solo
            hint="Select Source"
            persistent-hint
            @input="onFilter()"
          />
        </v-col>
      </v-row>
    </header>
    <v-data-table
      id="custom-table"
      :headers="headers"
      :items="orders"
      :page.sync="page"
      :items-per-page="itemsPerPage"
      :server-items-length="totalItems"
      :options.sync="pagination"
      :loading="isLoading"
      loading-text="Loading... Please wait"
      class="elevation-1 table-width"
      :footer-props="{
        'items-per-page-options': [5, 10, 25, 50, 100]
      }"
      @page-count="pageCount = $event"
    >
      <template v-slot:[`item.order_status`]="{ item }">
        <span>
          <v-chip
            v-if="constants.ORDER_STATUS[item.order_status.toLowerCase()] &&
              constants.ORDER_STATUS[item.order_status.toLowerCase()].color"
            small
            :color="constants.ORDER_STATUS[item.order_status.toLowerCase()].color "
            outlined
            dark
            class="mt-1 mr-3"
          >
            {{ constants.ORDER_STATUS[item.order_status.toLowerCase()].name }}
          </v-chip>
          <v-chip
            v-else
            small
            outlined
            :color="constants.ORDER_STATUS['default'].color"
            dark
            class="mt-1 mr-3"
          >
            {{ item.order_status | underscoreRemover }}
          </v-chip>
        </span>
      </template>
      <template v-slot:[`item.grand_total`]="{ item }">
        <span>${{ currencyFormat(item.grand_total) }}</span>
      </template>
      <template v-slot:[`item.order_date`]="{ item }">
        <span>{{ item.order_date | formatDate }}</span>
      </template>
      <template v-slot:[`item.source_type`]="{ item }">
        <span>{{ item.source_type | underscoreRemover }}</span>
      </template>
    </v-data-table>
  </v-container>
</template>
<script>
  import constants from '@core/config/constants'
  import { $orders } from "@core/services"
  import { mapGetters } from "vuex"
  export default {
    data () {
      return {
        breadcrumbs: [],
        contactId: '',
        sources: [],
        source: '',
        headers: [
          { text: 'Order Number', value: 'original_order_id', align: 'left', sortable: false, width: '25%' },
          { text: 'Order Status', align: 'left', value: 'order_status', sortable: true, width: '10%' },
          { text: 'Grand Total', value: 'grand_total', align: 'right', sortable: true, width: '10%' },
          { text: 'Order Date', value: 'order_date', align: 'left', sortable: true, width: '15%' },
          { text: 'Order Source', value: 'source_type', align: 'left', sortable: true, width: '10%' },
        ],
        orders: [],
        itemsPerPage: 10,
        totalItems: 0,
        pagination: { sortDesc: [true] },
        isLoading: false,
        pageCount: 0,
        page: 1,
        enableAttach: false,
        searchString: '',
        constants: constants,
        platform: process.env.VUE_APP_PRODUCT
      }
    },
    computed: {
      ...mapGetters({
        account: 'auth/account',
      }),
    },
    watch: {
      $route (to, from) {
        this.pagination.page = 1
        this.searchString = to.query.name
        this.fetchOrders()
      },
      pagination: {
        handler () {
          this.fetchOrders()
        },
        deep: true,
      },
    },
    mounted () {
      const { contactId, listId } = this.$route.params
      const platformBase = (this.platform == 'Marketing') ? 'accounts' : 'service'
      if (this.$route.query) {
        this.searchString = this.$route.query.name || ''
      }
      if (contactId) {
        this.contactId = contactId
        this.breadcrumbs = [
          {
            text: 'Contact Dashboard',
            disabled: false,
            /**
            * Manage Marketing Cloud-related conditions:
            * 1. Via the Dashboard
            * 2. Using the List View
            */
            href: (listId) ?
                `/${platformBase}/${this.account.id}/lists/${listId}/contacts/${contactId}` :
                `/${platformBase}/${this.account.id}/contacts/${contactId}`,
          },
          {
            text: 'Order Details',
            disabled: true,
          },
        ]
        /**
         * fetch sources
         */
        this.fetchAllSources()
        /**
         * fetch all orders by default
         */
        this.fetchOrders()
      }
    },
    methods: {
      /**
       * Method to get all sources list.
       */
      fetchAllSources () {
        $orders.orderTypes().then(response => {
          const resp = response.data.data.types
          var sources = [{ name: 'All', id: '' }]
          resp.forEach( (element) => {
            sources.push({
              id: element || 'null',
              name: (element == null)
                ? 'No Source'
                : element.toLowerCase().replace(/_/g, ' ').replace(/(?: |\b)(\w)/g, (key, p1) => {
                  return key.toUpperCase()
                }),
            })
          })
          this.sources = sources
        })
      },
      /**
       * @description Fetch existing feeds list
       */
      fetchOrders () {
        this.isLoading = true
        const { email } = this.$route.query
        const { sortBy, sortDesc, page, itemsPerPage } = this.pagination
        const sort = sortDesc.length ? (sortDesc[0] === true ? 'desc' : 'asc') : ''
        const payload = {
          page: page,
          per_page: itemsPerPage,
          contact_id: this.contactId,
        }
        if (email) { payload.email = email }
        if (sortBy[0]) { payload.method = sortBy[0] }
        if (sort) { payload.sort_by = sort }
        if (this.searchString) { payload.name = this.searchString }
        if (this.source !== '') { payload.source = this.source }
        /**
         * [GET] API call with required payload
         */
        $orders.fetch({
          params: payload,
        }).then(response => {
          const result = response.data.data
          this.orders = result.orders
          this.totalItems = result.meta.count
          if (this.itemsPerPage < 4 || this.totalItems < 10) {
            this.enableAttach = false
          }
        }).catch(error => {
          const data = error.response || error.request
          if (data.status === 500) {
            this.$store.commit('ui/snackbar', {
              message: 'Something went wrong. Please try again.',
              type: 'error',
            })
          }
        }).finally(() => {
          this.isLoading = false
        })
      },
      /**
       * @description Apply filter on order source
       */
      onFilter () {
        this.pagination.page = 1
        this.fetchOrders()
      },
      /**
       * @description only truncate Price(USD) value upto two decimal places
       * don't rounded off as per requirement
       * Example:
       * Input 1.99998 UI Out 1.99
       * Input 12343.456 UI output 12,343.45
       * Input 101 UI Out 101.00
       * Input 12.987 UI output 12.98
       */
      currencyFormat (price) {
        if (price && price !== 0) {
          const splittedValues = String(price).split('.')
          let decimalValue = splittedValues.length > 1 ? splittedValues[1] : ''
          decimalValue = decimalValue.concat('00').substr(0, 2)
          return `${Number(splittedValues[0]).toLocaleString()}.${decimalValue}`
        } else {
          return '0.00'
        }
      },
    },
  }
</script>
<style lang="scss" scoped>
.service-order-detail{
  .index-header-alignment {
    padding: 10px 0px 25px 10px;
  }
  .filter-order-by-source {
    padding-right: 10px;
  }
} 
</style>